function Facets({tags}) {
    return (
        <span>{tags}</span>
    )
}
  
export default Facets